import { GenderType } from "../Enums/ChoiceEnums";
import { getAge, NoTzDate } from "./DateUtils";

// ChoiceEntityUtils
export interface IChoiceEntity
{
    entity_id: number;

    first_name?: string;
    last_name?: string;
    middle_name?: string;

    birth_date?: NoTzDate;
    date_of_death?: NoTzDate;

    gender_code?: GenderType;
}

// Format a name as LastName, FirstName M.
export function formatName(entity: IChoiceEntity): string | undefined
{
    if (!entity)
        return;

    return `${entity.last_name}, ${entity.first_name} ${middleNameAbbr(entity)}`;
}

export function middleNameAbbr(entity: IChoiceEntity)
{
    let abbr = entity.middle_name?.substring(0, 1);
    if (abbr)
        abbr += ".";    
    return abbr;
}

export function age(entity: IChoiceEntity): number | undefined {
    return getAge(entity.birth_date);
}

export function genderDesc(entity: IChoiceEntity): string{
    switch(entity.gender_code){
        case GenderType.Female: 
        return "Female";

        case GenderType.Male: 
        return "Male";

        case GenderType.Unknown:
        default: 
        return "Unknown";
    }    
}

export function genderDescFromCode(genderCode: GenderType): string{
    switch(genderCode){
        case GenderType.Female: 
        return "Female";

        case GenderType.Male: 
        return "Male";

        case GenderType.Unknown:
        default: 
        return "Unknown";
    }    
}

